import type { Order } from '@src/orders/domain/Order';
import { OrderUnsavedChanges } from '@src/orders/unsavedChanges/OrderUnsavedChanges';
import type { Tractor } from '@src/tractor/domain/Tractor';
import type { TrailerListing } from '@src/trailer/domain/TrailerList';
import { useLocation } from 'react-router-dom';

export const useOrderUnsavedChanges = ({
  trailers,
  order,
  tractors,
}: {
  order: Order;
  trailers: TrailerListing[];
  tractors: Tractor[];
}) => {
  const location = useLocation();
  return {
    unsavedChanges: OrderUnsavedChanges.restore({
      location,
      tractors,
      trailers,
      currentFields: order.getFields().fields,
    }),
  };
};
